import React from "react";
import Modal from "react-bootstrap/Modal";
import "./alertBox.css";
import Button from "../ButtonComponent/Button";
import PropTypes from "prop-types";

const AlertBox = ({
  show,
  setShow,
  alertMessage,
  handleSubmit = () => setShow(false),
  // handleOut,
  buttonText = "OK",
}) => {
  return (
    <div>
      <Modal
        show={show}
        // onHide={handleSubmit}
        className="alertBoxModal"
      >
        <div className="contentContainerConfirmAlert">
          <Modal.Header closeButton>
            <Modal.Title>{alertMessage}</Modal.Title>
          </Modal.Header>
          <Modal.Footer>
            <div className="buttonOk">
              <Button text={buttonText} onClick={handleSubmit}></Button>
            </div>
          </Modal.Footer>
        </div>
      </Modal>
    </div>
  );
};

AlertBox.proptype = {
  setShow: PropTypes.func,
  show: PropTypes.bool,
  title: PropTypes.string,
  alertMessage: PropTypes.string,
  buttonSubmitText: PropTypes.string,
};
export default AlertBox;
